module.exports = __webpack_public_path__ + "portal-static/img/pie-two.d9d7652b.png";